import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, ControlContainer, FormControlDirective } from '@angular/forms';
import { DialogResult } from '@progress/kendo-angular-dialog';
import { Observable, BehaviorSubject } from 'rxjs';
import { AddCityDictionaryItemComponent } from 'src/app/shared/components/add-city-dictionary-item/add-city-dictionary-item.component';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { DictionaryDataItem } from 'src/app/shared/model/DictionaryDataItem';
import { CityDictionaryService } from 'src/app/shared/services/city-dictionary.service';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { ControlSettings } from '../../ControlSettings';
import { AutoComplete } from '../operators/autocomplete';

@Component({
  selector: 'city-combo-select-ctrl',
  templateUrl: './city-combo-select.component.html',
  styleUrls: ['./city-combo-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: CityComboSelectComponent,
    multi: true
  }]
})
export class CityComboSelectComponent implements ControlValueAccessor,OnInit  {

  constructor(protected controlContainer: ControlContainer, 
    private cityDictionaryService: CityDictionaryService,
    private customDialogService: CustomDialogService) {

  }

  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;

  @ViewChild("cityDialog", { read: ViewContainerRef })
  public containerRef: ViewContainerRef;
  

  @Input() public formControlName: string;
  @Input() caption: string;
 
  @Input() settings:ControlSettings = {};
  defaultSettings:ControlSettings = {fxFill:false};

  valuesList$: Observable<DictionaryDataItem[]>;
  term$ = new BehaviorSubject<string>('');

  textField  = 'value';
  valueField  = 'value';
 
  @Output() valueChangeEvent = new EventEmitter<any>();

  ngOnInit(): void {

     Object.assign(this.defaultSettings,this.settings);
    this.settings = this.defaultSettings;
    this.valuesList$ = this.term$.pipe(
      AutoComplete.autocomplete(200, (term => this.cityDictionaryService.getCities(term))));
    this.filterChange(this.control.value);
  }

  onChange(value: any) {

    this.valueChangeEvent.emit(value);
  }

  defineNewItem(){

    this.control.markAsTouched();

    const dialogSettings: CustomDialogSettings = {
      content: AddCityDictionaryItemComponent,
      appendTo: this.containerRef,
      maxWidth: '60vw',
      maxHeight: '60vh',
      dialogInputs: {
      },
      resultCallback: (r: DialogResult) => {
        if(r['text'] == 'OK') {
          const newCity = r['newCity'];
          if(newCity){
            this.filterChange(newCity);
            this.control.setValue(newCity);
          }
         }
      }
    };

    this.customDialogService.showDialog(dialogSettings);

  }


  public filterChange(filter: any): void {
      this.term$.next(filter);
  }

  public get control() {
    return this.controlContainer.control.get(this.formControlName);
  }


  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.filterChange(this.control.value)
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }
}


